import styles from './BankingIngestionLine.module.scss';
import PillArrowGlyph from '../PillArrowGlyph/PillArrowGlyph';

interface BankingIngestionLineProps {
    /** From `getBankingPendingStatus`, the same fetch `store/banking` already makes. */
    failedCount: number;
    onReviewClick: () => void;
}

/** "N bank statements not ingested. Review Now" beside the Banking tab title; nothing when N is 0. */
const BankingIngestionLine = ({ failedCount, onReviewClick }: BankingIngestionLineProps) => {
    if (!failedCount) return null;

    return (
        <div className={styles.Line} role="alert">
            {`${failedCount} bank statement${failedCount !== 1 ? 's' : ''} not ingested. `}
            <button className={styles.ReviewLink} onClick={onReviewClick}>
                Review Now
                <PillArrowGlyph className={styles.ReviewIcon} />
            </button>
        </div>
    );
};

export default BankingIngestionLine;
